import styled from 'styled-components';

import { spacingMixin } from '@belong/themes';
import { ISpacingProps } from '@belong/types';

import DefaultIcon from '../../Icon/Icon';
import Picture from '../../styles/Picture';
import { Copy } from '../../styles/Typography/Copy';

export const PrimaryIcon = styled(DefaultIcon)<{
  hasSmallIcon?: boolean;
  isActive?: boolean;
  withMarginLeft?: boolean;
}>`
  ${props => (props.hasSmallIcon ? '--iconSize: 2.4rem; margin-right: 1.1rem;' : 'margin-right: 0.8rem;')};
  ${props => (props.isActive === false ? 'filter: grayScale(100%); opacity: 0.5' : '')};
  ${props => (props.withMarginLeft && props.hasSmallIcon ? 'margin-left: 0.5rem;' : '')};
`;

export const PrimaryPicture = styled(Picture)`
  margin-right: 0.8rem;
`;

export const Container = styled.li<{ isTopAligned: boolean } & ISpacingProps>`
  ${spacingMixin}

  display: flex;
  align-items: ${props => (props.isTopAligned ? 'flex-start' : 'center')};
`;

export const Content = styled.div<{ isTopAligned: boolean }>`
  display: flex;
  flex: 1 1 100%;
  justify-content: space-between;
  align-items: ${props => (props.isTopAligned ? 'flex-start' : 'center')};
`;

export const PrimaryContent = styled.div`
  flex: 1 0 60%;
  a,
  span {
    display: inline;
  }
`;

export const Description = styled.div<{ isTopAligned?: boolean }>`
  padding-top: ${props => (props.isTopAligned ? '0' : '0.4rem')};
`;

export const Value = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1 1 40%;
  padding-left: 0.8rem;
  min-width: 0;

  ${Copy} {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export const ValueIcon = styled(DefaultIcon)`
  ~ ${Copy} {
    margin-left: 0.8rem;
  }
`;
